export default __webpack_public_path__ + "svg/powered/eoi-w.svg?330ed4cd";